"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("../../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const mapStateToProps = state => ({
  downloadapp: state.downloadapp
});
class DownloadApp extends _react.Component {
  render() {
    const {
      downloadapp
    } = this.props;
    let downloadLink = false;
    let downloadLinkMac = false;
    if (downloadapp.downloadLink) downloadLink = downloadapp.downloadLink;
    if (downloadapp.downloadLinkMac) downloadLinkMac = downloadapp.downloadLinkMac;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexFlow: 'column',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'container-fluid justify-content-left mt-5'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-narrow"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'd-flex mb-4'
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: 'page-title ml-0'
    }, "Download")), /*#__PURE__*/_react.default.createElement("div", {
      className: "card card-wide rounded shadow mb-3"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row m-0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col m-0 p-0"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: downloadapp.headerImage,
      className: " rounded-top",
      alt: "Download app"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("h4", null, downloadapp.headerText))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted"
    }, downloadapp.descriptionText))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, !downloadLink && /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      id: "downloadAppButton",
      className: "btn btn-primary mr-5",
      disabled: true
    }, "App not available"), downloadLink && /*#__PURE__*/_react.default.createElement("a", {
      href: downloadLink
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      id: "downloadAppButton",
      className: "btn btn-primary mr-5"
    }, downloadapp.downloadText)), downloadLinkMac && /*#__PURE__*/_react.default.createElement("a", {
      href: downloadLinkMac
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      id: "downloadMacAppButton",
      className: "btn btn-primary"
    }, downloadapp.downloadTextMac)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted"
    }, downloadapp.additionalText))))))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
  }
}
DownloadApp.propTypes = process.env.NODE_ENV !== "production" ? {
  downloadapp: _propTypes.default.object
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DownloadApp);
module.exports = exports.default;